var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 36C28.165 36 36 28.165 36 18.5C36 8.83502 28.165 1 18.5 1C8.83502 1 1 8.83502 1 18.5C1 28.165 8.83502 36 18.5 36Z",
    stroke: "#0A142F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4835 14.9671C15.3029 14.9671 15.9671 14.3029 15.9671 13.4835C15.9671 12.6642 15.3029 12 14.4835 12C13.6642 12 13 12.6642 13 13.4835C13 14.3029 13.6642 14.9671 14.4835 14.9671Z",
    fill: "#0A142F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7198 15.958H13.2473C13.1108 15.958 13 16.0688 13 16.2053V23.623C13 23.7595 13.1108 23.8703 13.2473 23.8703H15.7198C15.8563 23.8703 15.9671 23.7595 15.9671 23.623V16.2053C15.9671 16.0688 15.8563 15.958 15.7198 15.958Z",
    fill: "#0A142F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0883 15.5466C22.0315 15.1847 20.7097 15.5026 19.917 16.0728C19.8898 15.9665 19.7928 15.8874 19.6776 15.8874H17.205C17.0685 15.8874 16.9578 15.9981 16.9578 16.1346V23.5524C16.9578 23.6889 17.0685 23.7996 17.205 23.7996H19.6776C19.8141 23.7996 19.9249 23.6889 19.9249 23.5524V18.2215C20.3244 17.8773 20.8392 17.7675 21.2606 17.9465C21.669 18.1191 21.9029 18.5404 21.9029 19.1017V23.5524C21.9029 23.6889 22.0137 23.7996 22.1502 23.7996H24.6228C24.7593 23.7996 24.87 23.6889 24.87 23.5524V18.6037C24.8418 16.5718 23.8859 15.8196 23.0883 15.5466Z",
    fill: "#0A142F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.6336993d4d0cca0b7fb01f47feeeaafc.svg";
export { ForwardRef as ReactComponent };